export default __webpack_public_path__ + "static/media/P306.1.3058c2b0.mp3";